import React, { useEffect } from "react";
import { useStyles } from "../../assets/jss/ContentEngagementTab";
import {
  CustomPlayCircleOutlineIcon,
  CustomHelpOutlineIcon,
  CustomChatIcon,
  CustomErrorOutlineIcon,
} from "../CustomComponents/CustomIcon/CustomIcon";
import DateTime from "../DateTime/DateTime";
import clsx from "clsx";
import CustomLinearProgress from "../CustomComponents/CustomLinearProgress/CustomLinearProgress";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import { getSession } from "../../services/LocalStorageService";
import CustomLink from "../CustomComponents/CustomLink/CustomLink";
import moment from "moment";
import { getStartDate, getEndDate } from "../../services/LocalStorageService";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import ErrorStatusContext from "../../context/ErrorStatusContext";
import { getContentData } from "../../services/LearningAPI";
import trackEvents from "../../assets/appInsightsEvents";
import CustomSkeleton from "../CustomComponents/CustomSkeleton/CustomSkeleton";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { ActionStatus, ContentType, Role } from "../../config/app-globals.enum";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const ContentEngagementTabList = (props) => {
  const params = useParams();
  useEffect(() => {
    trackEvents("Content Engagement Driver Info", {
      userViewed: props.userId,
      type: props.contentType,
    }, params);
  }, []);

  const { t } = useTranslation();
  const classes = useStyles();
  const { userId, contentType } = props;
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [userSession] = React.useState(getSession);
  const [dataPageSize, setDataPageSize] = React.useState(null);
  const [dataPageIndex, setDataPageIndex] = React.useState(1);
  const [isMoreData, setIsMoreData] = React.useState(true);
  const [isResponseLength, setisResponseLength] = React.useState(true);
  const [startDate] = React.useState(getStartDate);
  const [endDate] = React.useState(getEndDate);
  const [isApiCalled, setIsApiCalled] = React.useState(false);
  const [isApiError, setIsApiError] = React.useState(false);

  const loadMoreData = () => {
    if (isMoreData) {
      const newPageindex =
        data && data.length > 0 ? data.length / dataPageSize + 1 : 1;
      setDataPageIndex(newPageindex);
    }
  };

  React.useEffect(() => {
    if (userSession) {
      setDataPageSize(userSession.pageLength);
    }
  }, [userSession]);

  React.useEffect(() => {
    if (data && data.length) {
      setIsMoreData(data.length % dataPageSize === 0 ? true : false);
    }
  }, [data]);

  //====
  const [statusValue, setStatusValue] = React.useState();
  const [alertMessage, setAlertMessage] = React.useState("");
  const [isAlertOpen, setIsAlertOpen] = React.useState(false);
  const changeApiStatusCodeFunc = (status) => {
    if (status && status.code && status.code !== 0 && status.code !== 200) {
      setStatusValue(status.code);
      setAlertMessage(
        status.message
          ? status.message
          : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
      );
      setIsAlertOpen(true);
    }
  };
  //====

  React.useEffect(() => {
    setLoading(true);
    setIsApiError(false);
    async function getUsersContent() {
      setStatusValue(null);
      setAlertMessage("");
      setIsAlertOpen(false);
      setIsApiCalled(true);
      const contentData = await getContentData(
        contentType,
        userId,
        dataPageIndex, params
      );
      if (
        contentData &&
        (contentData.status.code === 0 ||
          contentData.status.code === 200 ||
          contentData.status.code === 201) &&
        contentData.content
      ) {
        if (
          contentData.content &&
          contentData.content.contentList &&
          contentData.content.contentList.length
        ) {
          setData([...data, ...contentData.content.contentList]);
        }
        if (!contentData.content || contentData.content.contentList.length === 0) {
          setisResponseLength(false);
        }
        setIsApiCalled(false);
        setLoading(false);
      } else {
        setIsApiCalled(false);
        setisResponseLength(false);
        setIsApiError(true);
        setLoading(false);
        changeApiStatusCodeFunc(contentData.status);
      }
    }
    getUsersContent();
  }, [dataPageIndex]);

  const checkDate = (itemData) => {
    let selectedStartDate = new Date(startDate);
    let selectedEndDate = new Date(endDate);
    selectedStartDate.setHours(0, 0, 0, 0);
    selectedEndDate.setHours(23, 59, 59, 999);

    const isBetweenDate = moment(itemData).isBetween(selectedStartDate, selectedEndDate);
    return isBetweenDate;
  };
  return (
    <>
      {data && data.length > 0 ? (
        <div className={classes.list}>
          {data.map((content, index) => {
            return (
              <CustomBox
                component={checkDate(content.assignedDate) ? "div" : "span"}
                key={`${content.contentId}-${index}-${Math.floor(
                  Math.random() * 101
                )}`}
                className={clsx(
                  classes.listItem,
                  checkDate(content.assignedDate)
                    ? classes.listItemWithinDateRange
                    : null
                )}
              >
                <div className={classes.icon}>
                  {content.contentTypeId === ContentType.DRIVING_VIDEO ? (
                    <CustomPlayCircleOutlineIcon />
                  ) : content.contentTypeId === ContentType.EMAIL_MESSAGE ? (
                    <CustomChatIcon />
                  ) : content.contentTypeId === ContentType.ANIMATION ? (
                    <CustomPlayCircleOutlineIcon />
                  ) : content.contentTypeId === ContentType.ARTICLE ? (
                    <CustomChatIcon />
                  ) : content.contentTypeId === ContentType.QUIZ ? (
                    <CustomHelpOutlineIcon />
                  ) : (
                    <CustomPlayCircleOutlineIcon />
                  )}
                </div>
                <div className={classes.content}>
                  <span className={classes.contentText}>
                    <CustomLink
                      className={classes.contentTextLink}
                      href={`/contents/${content.contentId
                        }`}
                      target="contentEngagementWindow1"
                    >
                      {content.title}
                    </CustomLink>
                  </span>
                  <span className={classes.contentSubText}>
                    <strong>{t("SENT")}: </strong>
                    <DateTime
                      inputDate={content.assignedDate}
                      returnFormat="ddd"
                    />
                    ,{" "}
                    <DateTime
                      inputDate={content.assignedDate}
                      returnFormat="DD MMM YYYY"
                    />
                  </span>
                </div>
                <div className={classes.progress}>
                  <span
                    className={clsx(
                      classes.progressLabel,
                      content.actionStatus === ActionStatus.COMPLETED ? classes.activeLabel : null
                    )}
                  >
                    {content.contentTypeId === ContentType.EMAIL_MESSAGE ||
                      content.contentTypeId === ContentType.ARTICLE ? (
                      content.actionStatus === ActionStatus.COMPLETED ? (
                        <>{t("SEEN")}</>
                      ) : (
                        <>{t("UNSEEN")}</>
                      )
                    ) : (content.actionStatus === ActionStatus.COMPLETED) ? (
                      <>{t("COMPLETED")}</>
                    ) : content.actionStatus === ActionStatus.ATTEMPTED ? (
                      <>{t("IN_PROGRESS")}</>
                    ) : (content.actionStatus === ActionStatus.EXPIRED && content.contentCompletedPercentage > 0) ? (
                      <>{t("IN_PROGRESS")}</>
                    ) : (
                      <>{t("NOT_STARTED")}</>
                    )}
                  </span>
                  {(content.contentTypeId === ContentType.DRIVING_VIDEO ||
                    content.contentTypeId === ContentType.ANIMATION) && (
                      <CustomLinearProgress
                        className={classes.progressBar}
                        value={content.contentCompletedPercentage}
                        variant="determinate"
                      />
                    )}
                </div>
              </CustomBox>
            );
          })}
        </div>
      ) : (
        <div className={classes.list}>
          <div className={classes.listItem}>
            <div className={classes.icon}>
              <CustomErrorOutlineIcon />
            </div>
            <div className={classes.content}>
              {!isApiError ? (
                <span className={classes.contentText}>
                  {isApiCalled
                    ? t("LOADING_DATA")
                    : contentType === "ACTIVE"
                      ? t("NO_ACTIVE_CONTENT")
                      : t("NO_COMPLETED_CONTENT")}
                </span>
              ) : (
                <>
                  <span className={classes.contentText}>
                    <CustomSkeleton animation="wave" width={200} height={20} />
                  </span>
                  <span className={classes.contentSubText}>
                    <CustomSkeleton animation="wave" width={100} height={15} />
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {isMoreData && isResponseLength ? (
        <div className={classes.loadMore} onClick={() => loadMoreData()}>
          {loading ? <CustomCircularProgress /> : t("LOAD_MORE")}
        </div>
      ) : (
        <div className={classes.loadMore}>
          {isApiError
            ? `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            : `${t("NO_MORE_DATA")}...`}
        </div>
      )}
      <ErrorAlert
        code={statusValue}
        message={alertMessage}
        isOpen={isAlertOpen}
        isClose={(isClose) => setIsAlertOpen(!isClose)}
      />
    </>
  );
};

export default ContentEngagementTabList;
